export default __webpack_public_path__ + "static/media/slack.b04c977c.svg";